import { Component, ViewEncapsulation } from '@angular/core';
import { fadeInOutAnimation } from '@app/core/animations';
import { ResponsiveState } from '@app/core/states/responsive.state';
import { UIState } from '@app/ui/states/ui.state';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'rk-main-container',
  templateUrl: './main-container.component.html',
  styleUrl: './main-container.component.scss',
  encapsulation: ViewEncapsulation.None,
  animations: [fadeInOutAnimation],
  standalone: false,
})
export class MainContainerComponent {
  @Select(ResponsiveState.showAppManagerMobileWarning)
  showAppManagerMobileWarning$: Observable<boolean>;

  @Select(UIState.isCreationProcess)
  isCreationProcess$: Observable<boolean>;
}
